import { takeEvery, call, put } from "redux-saga/effects";
import { VALIDATE_TOKEN_REQUEST } from "./actionTypes";
import { validateTokenFailure, validateTokenSuccess } from "./actions";
import { axiosApi } from "helpers/api_helper";
import { POST_VALIDATE_TOKEN } from "constants/api_constants";
import { clearLocalStorage } from "../login/saga";
import secureLocalStorage from "react-secure-storage";

function* validateToken() {
  const token = JSON.parse(secureLocalStorage.getItem("token"));
  const email = JSON.parse(secureLocalStorage.getItem("email"));

  if (!token) {
    yield put(validateTokenFailure("No token found"));
    return;
  }

  try {
    const response = yield call(axiosApi.post, POST_VALIDATE_TOKEN, {
      token,
      email,
    });

    if (response.data === "Token is valid.") {
      yield put(validateTokenSuccess(response.data));
    } else {
      clearLocalStorage();
      yield put(validateTokenFailure(response.data));
    }
  } catch (error) {
    clearLocalStorage();
    yield put(validateTokenFailure("Server error"));
  }
}

function* watchValidateToken() {
  yield takeEvery(VALIDATE_TOKEN_REQUEST, validateToken);
}

export default watchValidateToken;
